jQuery(function () {
  var iframeAPIStatus = "unloaded";

  if (jQuery(".youtube-player").length) {
    addPlayListeners();
  }

  listenForDynamicallyAddedPlayers();

  function addPlayListeners() {
    if (iframeAPIStatus == "unloaded") {
      addIframeAPI();
    } else if (iframeAPIStatus == "loaded") {
      jQuery(".youtube-player").each(function () {
        addPlayListener(this);
      });
    }
  }

  function addIframeAPI() {
    iframeAPIStatus = "loading";

    window.onYouTubeIframeAPIReady = function () {
      iframeAPIStatus = "loaded";
      addPlayListeners();
    };

    var tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  var videoIndex = 0;
  function addPlayListener(iframe) {
    if (iframe.playListenerAdded) {
      return;
    }

    // An id is required by YT.Player, so create a dynamic one if the iframe doesn't already have one
    if (!iframe.id.length) {
      iframe.id = "youtube-iframe-" + videoIndex;
      videoIndex += 1;
    }

    var player = new YT.Player(iframe.id, {
      events: {
        onStateChange: function (event) {
          if (event.data == YT.PlayerState.PLAYING) {
            jQuery(event.target.getIframe()).trigger("embed:play.sparkle", [
              "youtube",
              player.getVideoData().title,
              player.getDuration(),
            ]);
          } else if (event.data == YT.PlayerState.PAUSED) {
            jQuery(event.target.getIframe()).trigger("embed:pause.sparkle");
          } else if (event.data == YT.PlayerState.ENDED) {
            jQuery(event.target.getIframe()).trigger("embed:ended.sparkle");
          }
        },
      },
    });

    iframe.playListenerAdded = true;
  }

  function listenForDynamicallyAddedPlayers() {
    document.addEventListener(
      "load",
      function (e) {
        if (jQuery(e.target).is(".youtube-player")) {
          addPlayListeners();
        }
      },
      true,
    );
  }
});
